import { contactContent } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{contactContent.title}</h2>
          <p className="mt-1 text-base font-heading text-primary-600">{contactContent.subtitle}</p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{contactContent.desc}</p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮箱投稿</h3>
              <p className="text-xs text-primary-600 break-all">{contactContent.email}</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
              <p className="text-xs text-foreground-600">{contactContent.wechat}</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-secondary-200 text-secondary-700 mb-3">
                <i className="ri-qq-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">QQ群</h3>
              <p className="text-xs text-foreground-600">{contactContent.qq}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}